<div class="icon">
  <onyx-icon name="vehicle-ride-filled" [size]="16"></onyx-icon>
</div>
